import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

export class Elle extends Lit3formBlock {
  static get characterName() {
    return 'elle';
  }

  static get characterProperties() {
    return {
      cta: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid elle-layout">
          ${this.headerHTML} ${this.descriptionHTML} ${this.imagesHTML}
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get imagesHTML() {
    return this.imagesArr.length
      ? html`
          <div class="images">
            ${this.imagesArr.map(
              i => html`
                <driver-card
                  class="image-wrapper"
                  .card=${i[1]}
                  placement=${this.analyticsBlockLabel}
                  download-placement=${this.headerText}
                  image-width="500"
                >
                  <cta-text
                    cta-data=${this.imageCtaData(i[1])}
                    .ctaAnalyticsData=${analyticsCtaDataObject(
                      i[1],
                      this.headerText
                    )}
                  ></cta-text>
                </driver-card>
              `
            )}
          </div>
        `
      : html``;
  }

  imageCtaData(image) {
    let cta = {};
    if (image) {
      cta.text = image.text;
      cta.url = image.url;
      cta.fontSize = 'large';
    }
    return JSON.stringify(cta);
  }

  get headerHTML() {
    return this.headerText
      ? html`
          <h1 class="header">${unsafeHTML(this.headerText)}</h1>
        `
      : ``;
  }

  get descriptionHTML() {
    return this.descriptionText
      ? html`
          <p class="description">
            ${unsafeHTML(this.descriptionText)}
          </p>
        `
      : ``;
  }
}
Elle.defineElement();
